import { createApi } from '@reduxjs/toolkit/query/react'
import { GET_CHAT } from 'config/apiPaths';
import { CHAT_SERVER_URL } from 'config/constants';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const chatApi = createApi({
    reducerPath: 'chatApi',
    baseQuery: axiosBaseQuery({
        baseUrl: CHAT_SERVER_URL,
    }),
    tagTypes: ["Chat"],
    endpoints: (builder) => ({

        // staff list
        getChat: builder.query({
            query: ({ caseloadId = "", page = 1, limit = 10 }) => ({
                method: "PATCH",
                url: GET_CHAT,
                data: { caseloadId, page, limit }
            }),

            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["Chat"]
        }),
    })
})

export const {
    useGetChatQuery
} = chatApi;